/* eslint-disable no-nested-ternary */
import React from 'react';
import cx from 'classnames';

import { ReactComponent as FallbackLogo } from 'app/components/svg/FallbackLogo.svg';

import s from './TokenImage.module.sass';

type TokenImageProps = {
  firstTokenImage: string | null
  secondTokenImage?: string | null
  className?: string
  sizeT?: keyof typeof sizeClass
  tokensNames: {
    firstTokenName: string
    secondTokenName?: string
  }
};

const sizeClass = {
  small: s.small,
  medium: s.medium,
  large: s.large,
};

const TokenImage: React.FC<TokenImageProps> = ({
  firstTokenImage,
  secondTokenImage,
  sizeT = 'small',
  tokensNames,
  className,
}) => {
  const compoundClassName = cx(
    s.root,
    { [s.pairs]: typeof secondTokenImage === 'object' || secondTokenImage },
    sizeClass[sizeT],
    className,
  );

  return (
    <div className={compoundClassName}>
      {firstTokenImage ? (
        <img
          src={firstTokenImage}
          alt={tokensNames.firstTokenName}
          className={cx(s.image)}
        />
      ) : (
        <FallbackLogo className={cx(s.image)} />
      )}

      {typeof secondTokenImage === 'string' && (
      <img
        src={secondTokenImage}
        alt={tokensNames.secondTokenName}
        className={cx(s.image)}
      />
      )}

      {
        typeof secondTokenImage === 'object' && (
          <FallbackLogo className={cx(s.image)} />
        )
      }
    </div>
  );
};

export default TokenImage;
